import React from 'react'
import { Redirect } from 'react-router'
import RestrictedRoute from 'rmw-shell/lib/containers/RestrictedRoute'
export const ClientRoute = props => {
  if (props && props.computedMatch && props.computedMatch.params && props.computedMatch.params.clientId === '0') {
    return (
      <Redirect
        to={{
          pathname: '/select_client',
          search: `for=${props.location.pathname}`,
          state: { for: props.location }
        }}
      />
    )
  } else {
    return <RestrictedRoute {...props} />
  }
}

export default ClientRoute
